import type { SVGProps } from 'react'

const SvgDataCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.275 6.64583L14.5063 3.39167L13.8646 2.75L11.275 5.33958L9.96875 4.03333L9.32708 4.69792L11.275 6.64583ZM0 15.5833V13.75H11V15.5833H0ZM8.67396 7.82604C7.78021 6.93229 7.33333 5.85139 7.33333 4.58333C7.33333 3.31528 7.78021 2.23437 8.67396 1.34062C9.56771 0.446875 10.6486 0 11.9167 0C13.1847 0 14.2656 0.446875 15.1594 1.34062C16.0531 2.23437 16.5 3.31528 16.5 4.58333C16.5 5.85139 16.0531 6.93229 15.1594 7.82604C14.2656 8.71979 13.1847 9.16667 11.9167 9.16667C10.6486 9.16667 9.56771 8.71979 8.67396 7.82604ZM0 8.25V6.41667H5.775C5.88194 6.75278 6.00417 7.07361 6.14167 7.37917C6.27917 7.68472 6.44722 7.975 6.64583 8.25H0ZM0 11.9167V10.0833H8.61667C8.96806 10.2972 9.34236 10.4767 9.73958 10.6219C10.1368 10.767 10.5569 10.8701 11 10.9312V11.9167H0Z"
      fill="#F6426F"
    />
  </svg>
)
export default SvgDataCheck
